import { Component, computed, Signal } from '@angular/core';
import { DataItemTemplate } from '../../../templates/data-item-template/data-item-template';
import { Icon } from '../../icon/icon';
import { ProgressIcon } from '../../progress-icon/progress-icon';

@Component({
  selector: 'li[app-calories-data-item-block]',
  imports: [Icon, DataItemTemplate, ProgressIcon],
  template: `
    <app-data-item-template [dataBlock]="dataBlock()">
      @if (percent()) {
        <app-progress-icon [size]="iconSize()" icon="calories" [percent]="percent()!" />
      } @else {
        <app-icon [size]="iconSize()" class="icon" icon="calories" />
      }
      <p class="name">kcal</p>
      <p class="value">{{ value() }}</p>
    </app-data-item-template>
  `,
  styleUrl: './calories-data-item-block.scss',
})
export class CaloriesDataBlockItem extends DataItemTemplate {
  value: Signal<number> = computed(() =>
    Math.round(this.webSocketService.broadcastData()?.data.calories || 0),
  );
  objectif: Signal<number | undefined> = computed<number | undefined>(() => undefined);
  percent: Signal<number | undefined> = computed<number | undefined>(() => {
    if (!this.objectif()) return undefined;
    return (this.objectif()! / this.value()) * 100;
  });
}
